import type { SVGProps } from 'react'
const SvgSyTickSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.666 2c-1.687 0-3.144.618-4.14 1.688C2.527 4.758 2 6.246 2 7.916v8.168c0 1.67.527 3.158 1.523 4.229S5.975 22 7.666 22h8.668c1.692 0 3.146-.617 4.143-1.687S22 17.753 22 16.084V7.916c0-1.67-.525-3.158-1.521-4.228C19.482 2.618 18.025 2 16.334 2zm0 1.5h8.668c1.338 0 2.34.453 3.045 1.209S20.5 6.559 20.5 7.916v8.168c0 1.358-.417 2.45-1.121 3.207S17.673 20.5 16.334 20.5H7.666c-1.338 0-2.341-.453-3.045-1.209S3.5 17.441 3.5 16.084V7.916c0-1.357.418-2.45 1.123-3.207S6.333 3.5 7.666 3.5"
				clipRule="evenodd"
			/>
			<path
				d="M15.56 8.877a.75.75 0 0 0-.53.22l-4.216 4.216-1.843-1.842a.75.75 0 0 0-1.06 0 .75.75 0 0 0 0 1.06l2.372 2.373a.75.75 0 0 0 1.06 0l4.747-4.746a.75.75 0 0 0 0-1.06.75.75 0 0 0-.53-.221"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyTickSquare
